// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextContainer_wrapper__kKdPE","inverted":"TextContainer_inverted__3KI0g","disabled":"TextContainer_disabled__13fP7"};